export const GET_ALL_USERS = 'get_all_users';
export const GET_ALL_USERS_SUCCESS = 'get_all_users_success';
export const DELETE_USER = 'delete_user';
export const ADD_GUEST_USER = 'add_guest_user';
export const CHANGE_USER_STATUS = 'change_user_status';
export const CHANGE_USER_STATUS_CHAT = 'change_user_status_chat';
export const ADD_RESTRICTED_USER = 'add_restricted_user';
